"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saga = exports.signInRequestSaga = exports.errorSignInReset = exports.signInClear = exports.signInByServiceError = exports.signInByService = exports.signInByPhone = exports.signInByUsername = exports.signIn = exports.reducers = exports.defaultState = exports.entityName = void 0;
var effects_1 = require("redux-saga/effects");
var common_1 = require("../common");
var config_1 = require("../../config");
var index_1 = require("./index");
/**
 * Constants
 * */
exports.entityName = 'signIn';
var signInEntity = (0, common_1.getConfig)(exports.entityName);
exports.defaultState = {
    signIn: {
        response: null,
        loading: false,
        error: null,
    },
};
/**
 * Reducer
 * */
exports.reducers = {
    signIn: function () {
        // trigger action signIn
    },
    signInStart: function (state) {
        state.signIn.error = null;
        state.signIn.loading = true;
    },
    signInSuccess: function (state, _a) {
        var payload = _a.payload;
        state.signIn.loading = false;
        state.signIn.response = payload || null;
        state.authorized = true;
        Object.assign(state, payload, {
            remember: (payload === null || payload === void 0 ? void 0 : payload.remember) || false,
        });
    },
    signInError: function (state, _a) {
        var payload = _a.payload;
        state.signIn.loading = false;
        state.signIn.error = payload;
    },
    signInErrorReset: function (state) {
        state.signIn.loading = false;
        state.signIn.error = null;
    },
    signInClear: function (state) {
        state.signIn.loading = false;
        state.signIn.response = null;
    },
};
var signIn = function (payload) { return ({
    type: config_1.config.actions.signIn.type,
    payload: payload,
    data: { type: 'byEmail' },
}); };
exports.signIn = signIn;
var signInByUsername = function (payload) { return ({
    type: config_1.config.actions.signIn.type,
    payload: payload,
    data: { type: 'byUsername' },
}); };
exports.signInByUsername = signInByUsername;
var signInByPhone = function (payload) { return ({
    type: config_1.config.actions.signIn.type,
    payload: payload,
    data: { type: 'byPhone' },
}); };
exports.signInByPhone = signInByPhone;
var signInByService = function (payload) { return ({
    type: config_1.config.actions.signIn.type,
    payload: payload,
    data: { type: 'byService' },
}); };
exports.signInByService = signInByService;
var signInByServiceError = function (payload) { return ({
    type: config_1.config.actions.signInError.type,
    payload: payload,
}); };
exports.signInByServiceError = signInByServiceError;
var signInClear = function () { return ({
    type: config_1.config.actions.signInClear.type,
}); };
exports.signInClear = signInClear;
var errorSignInReset = function () { return ({
    type: config_1.config.actions.signInErrorReset.type,
}); };
exports.errorSignInReset = errorSignInReset;
/**
 * Sagas
 */
function signInRequestSaga(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, index_1.sendRequest)(index_1.fetchAuthSaga, exports.entityName, signInEntity, action)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.signInRequestSaga = signInRequestSaga;
function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(config_1.config.actions.signIn.type, (0, common_1.defaultProcessingSaga)(signInRequestSaga, {
                    error: config_1.config.actions.signInError.type,
                    locationCancel: config_1.config.actions.signInClear.type,
                }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(config_1.config.actions.signInSuccess.type, function clear() {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!signInEntity.delaySuccess) return [3 /*break*/, 2];
                                    return [4 /*yield*/, (0, effects_1.delay)(signInEntity.delaySuccess)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2: return [4 /*yield*/, (0, effects_1.put)({
                                        type: config_1.config.actions.signInClear.type,
                                    })];
                                case 3:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    })];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(config_1.config.actions.signInError.type, function errorReset() {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!signInEntity.delayError) return [3 /*break*/, 2];
                                    return [4 /*yield*/, (0, effects_1.delay)(signInEntity.delayError)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2: return [4 /*yield*/, (0, effects_1.put)({
                                        type: config_1.config.actions.signInErrorReset.type,
                                    })];
                                case 3:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    })];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.saga = saga;
